import { Amplify } from "aws-amplify";
import apiConfigOptions, { libraryOptions } from "../../api-config.js";

const configureAuth = async () => {
  const { customAuthStorage, ...config } = apiConfigOptions;
  Amplify.configure(config, libraryOptions);
};

export default configureAuth;
